export default "__VITE_ASSET__wHEEyLTD__"